import { GetToSStatusParams } from 'multirpc-sdk';
import { useMemo } from 'react';

import { IUseQueryProps } from 'store/queries/types';
import { getQueryParams } from 'store/utils/getQueryParams';
import { useAppSelector } from 'store/useAppSelector';

import {
  selectToSStatus,
  selectToSStatusLoading,
  selectToSStatusState,
  useFetchToSStatusQuery,
  useLazyFetchToSStatusQuery,
} from '../actions/negativeBalanceTermsOfServices/fetchToSStatus';

export interface IUseToSStatusProps
  extends GetToSStatusParams,
    IUseQueryProps {}

export const useToSStatus = ({ group, skipFetching }: IUseToSStatusProps) => {
  const params = useMemo((): GetToSStatusParams => ({ group }), [group]);

  useFetchToSStatusQuery(getQueryParams({ params, skipFetching }));

  const [handleFetchToSStatus] = useLazyFetchToSStatusQuery();

  const tosStatus = useAppSelector(state => selectToSStatus(state, params));
  const loading = useAppSelector(state =>
    selectToSStatusLoading(state, params),
  );
  const state = useAppSelector(storeState =>
    selectToSStatusState(storeState, params),
  );

  return {
    handleFetchToSStatus,
    loading,
    params,
    state,
    tosStatus,
  };
};
